import {
  BrowserAuthError,
  InteractionRequiredAuthError,
} from "../auth/cognito-browser";
import { enrichLoansWithNicknames, getLoans } from "../../data/loanAPI";
import { getLoanId, normalizeLoansList } from "./utility-functions";
import {
  BORROWER,
  CLIENT,
  CLIENT_ADMIN,
  CLIENT_ADMIN_ROLE,
  PAYMENTS_BORROWER_ROLE,
  PAYMENTS_SUPPORT_ROLE,
} from "../constants/Roles.constants";

/** App logout screen — Cognito sign-out completes here and returns via postLogoutRedirectUri. */
export const LOGOUT_ROUTE_PATH = "/logout";

export function redirectToLogoutPage() {
  const publicUrl = (process.env.PUBLIC_URL || "").replace(/\/$/, "");
  const logoutPath = `${publicUrl}${LOGOUT_ROUTE_PATH}`;
  const target = `${window.location.origin}${logoutPath}`;

  if (window.location.pathname !== logoutPath) {
    window.location.assign(target);
  }
}

export const acquireToken = (
  instance,
  requestParams,
  loanInfo,
  addPendingRequest,
  removePendingRequest,
  setMissingTenant,
  userRoles,
  impersonatedUser,
  saveToken = false,
  tokenSetter = () => {},
) => {
  if (sessionStorage.getItem("co")) {
    setMissingTenant(false);
    addPendingRequest();
    instance
      .acquireTokenSilent(requestParams)
      .then((tokenResponse) => {
        removePendingRequest();
        if (saveToken) {
          tokenSetter(tokenResponse.accessToken);
        }
        if (loanInfo.checkLoans) {
          callLoansApi(
            tokenResponse.accessToken,
            loanInfo.loans,
            loanInfo.setLoans,
            loanInfo.setActiveLoan,
            addPendingRequest,
            removePendingRequest,
            userRoles,
            impersonatedUser,
          );
        }
      })
      .catch((error) => {
        if (sessionStorage.getItem("co")) {
          setMissingTenant(false);
          addPendingRequest();
          if (
            error instanceof InteractionRequiredAuthError ||
            error instanceof BrowserAuthError
          ) {
            instance
              .acquireTokenRedirect(requestParams)
              .then((tokenResponse) => {
                removePendingRequest();
                if (saveToken) {
                  tokenSetter(tokenResponse.accessToken);
                }
                if (loanInfo.checkLoans) {
                  callLoansApi(
                    tokenResponse.accessToken,
                    loanInfo.loans,
                    loanInfo.setLoans,
                    loanInfo.setActiveLoan,
                    addPendingRequest,
                    removePendingRequest,
                    userRoles,
                    impersonatedUser,
                  );
                }
              })
              .catch((innerError) => {
                removePendingRequest();
                console.log(innerError);
              });
          } else {
            removePendingRequest();
            console.log(error);
          }
        } else {
          setMissingTenant(true);
        }
      });
  } else {
    setMissingTenant(true);
  }
};

export const callLoansApi = async (
  token,
  loans,
  setLoans,
  setActiveLoan,
  addPendingRequest,
  removePendingRequest,
  userRoles,
  impersonatedUser,
) => {
  let loanDetails = null;
  if (loans === null) {
    addPendingRequest();
    loanDetails = await getLoans(token, userRoles, impersonatedUser);
    const loanList = await enrichLoansWithNicknames(
      token,
      normalizeLoansList(loanDetails),
      impersonatedUser,
    );
    setLoans(loanList);
    removePendingRequest();
    if (loanList.length > 0) {
      setActiveLoan(getLoanId(loanList[0]));
    } else {
      setActiveLoan("no-loan");
    }
  }
};

export const determineRoleLabel = (roleValue) => {
  switch (roleValue) {
    case PAYMENTS_BORROWER_ROLE:
      return BORROWER;
    case PAYMENTS_SUPPORT_ROLE:
      return CLIENT;
    case CLIENT_ADMIN_ROLE:
      return CLIENT_ADMIN;
    default:
      return roleValue;
  }
};
